var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-layout',{attrs:{"layout-classes":_vm.layoutClasses}})
}
var staticRenderFns = []

export { render, staticRenderFns }